$(function () {
    document_ready();
    window_onload();
});

function document_ready() {
    ts = (new Date()).getTime();
    $("body").addClass("ready");

    var os = navigator.platform.toLowerCase();
    if (os.indexOf("mac") != -1) {
        $("body").addClass("mac");
    }

    //responsive_init();
    init_event_handlers();

    bind_widgets();
    $(document).ajaxStop(function () {
        bind_widgets();
    });

    //scroll_animations_init();

    te = (new Date()).getTime();
    console.log("On-Ready Load Time: ", te - ts);
}

function window_onload() {
    ts = (new Date()).getTime();
    $("body").addClass("win-loaded").removeClass("win-not-loaded");
    /*$(document).imagesLoaded(function () {
        te = (new Date()).getTime();
        console.log("Images Load Time: ", te - ts);
        setTimeout(function () {
            $("body").addClass("loaded").removeClass("not-loaded");
        }, 10);
    });*/

    //responsive_update();
    //lazy_load();

    te = (new Date()).getTime();
    console.log("Window Load Time: ", te - ts);
}

$(window).scroll(function () {
    if (typeof $("body").data("scrollval") === "undefined") $("body").data("scrollval", 0);

    //scroll_animations();
    //lazy_load();
    $("body").data("scrollval", $(window).scrollTop());
});

function init_event_handlers() {
    //fix_touch_hovers();
    //click_touch_init();


    $(document).on("click",".js-link",function () {
        $("body,html").animate({"scrollTop":0},"slow");
        return false;
    });


    ajaxHandlersInit();




}

$(window).on("resize orientationchange", function (e) {
    //responsive_update();
    //scroll_animations();
});

function bind_widgets() {
    img_to_bg();
    //slider_init();
    fancybox_init();
    //gmap_load();
    validate_init();
    mask_init();
    checkbox_plain_init();
    ui_slider_init();
    //datepickerinit();
}

